


















import Vue, { PropType } from "vue";
import { Chart } from "chart.js";
import { Data, Methods, Computed, Props } from "./types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "RadarChart",
  components: {
    Heading
  },
  props: {
    chartConfig: {
      type: Object as PropType<Props["chartConfig"]>,
      required: true
    }
  },
  data() {
    return {
      bindTo: `radarChart-${this.chartConfig.category}`,
      chart: null
    };
  },
  computed: {
    noChartData() {
      const datasets: Chart.ChartDataSets[] = this.chartConfig.config.data!
        .datasets!;
      return datasets.every(dataset => dataset.hidden || !dataset.data![0]);
    }
  },
  mounted() {
    this.generateChart();
    this.$watch("chartConfig", () => this.generateChart());
  },
  methods: {
    generateChart() {
      if (this.chart) this.chart.destroy();

      const canvas = document.getElementById(this.bindTo) as HTMLCanvasElement;
      const ctx = canvas && canvas.getContext("2d");

      if (!ctx || !this.chartConfig) return;

      this.chart = new Chart(ctx, this.chartConfig.config);
    }
  }
});
